import { Component, OnInit } from '@angular/core';
import { UxService } from '~/app/core/services';
import { NewDesignationBaseComponent } from '~/app/open-age/directory/components/new-designation-base.component';
import { DesignationService } from '~/app/open-age/directory/services';

@Component({
  selector: 'directory-designation-wiz',
  templateUrl: './designation-new.component.html',
  styleUrls: ['./designation-new.component.css']
})
export class DesignationNewComponent extends NewDesignationBaseComponent {

  constructor(
    api: DesignationService,
    uxService: UxService
  ) {
    super(api, uxService);
  }

}
